<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>教师岗位业绩、津贴汇总</h3>
                <p></p>
            </div>
            <div>
                <a-card  :bordered="false" style="width:100%;margin-top:1rem" headStyle="font-size:1vw">
                    <template slot="title">
                        <a-icon type="profile" /> 基本信息
                    </template>
                    <div class="info-main">
                        <div class="input-box">
                            <p class="long-p">姓名：</p>
                            <a-select 
                                :disabled="type=='look'"
                                class="short-input" 
                                allowClear
                                show-search
                                :filter-option="filterOption"
                                v-model="info.teacherName"
                                @change="teacherChange"
                                option-label-prop="label"
                                >
                                <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherName" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                            </a-select>
                        </div>
                        <div class="input-box">
                            <p class="long-p">部门：</p>
                            <a-input class="short-input" style="background-color:#f5f5f5" v-model="info.orgName" disabled />
                        </div>
                        <div class="input-box">
                            <p class="long-p">学年：</p>
                            <a-date-picker
                                class="short-input"
                                mode="year"
                                format='YYYY'
                                v-model="year" 
                                :open='yearShowOne' 
                                @openChange="openChangeOne"
                                @panelChange="panelChangeOne">
                                <a-input  v-model="info.schoolYear" :disabled="type=='look'"/>
                            </a-date-picker>
                        </div>
                        <div class="input-box">
                            <p class="long-p">职称：</p>
                            <a-input class="short-input" v-model="info.technicalTitleName" disabled />
                        </div>
                        <div class="input-box">
                            <p class="long-p">岗位工作量津贴：</p>
                            <a-input-number 
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            class="short-input" v-model="info.postMoney"  disabled/>
                        </div>
                    </div>
                </a-card>
                <a-card :bordered="false" style="width:100%;margin-top:1rem" headStyle="font-size:1vw">
                    <template slot="title">
                        <a-icon type="menu-fold" /> 津贴概要
                    </template>
                    <div class="info-main">
                        <div class="input-box">
                            <p class="long-p">总分：</p>
                            <a-input-number class="short-input" v-model="info.totalScore"  disabled/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">规定基本工作量（最低值）：</p>
                            <a-input-number class="short-input"  v-model="info.minWorkload" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">实际超工作量分：</p>
                            <a-input-number class="short-input" v-model="info.actualExcess" disabled/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">超工作量金额(600元/分）：</p>
                            <a-input-number 
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            class="short-input" v-model="info.aeMoney" disabled/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">非全日制教学费用：</p>
                            <a-input-number 
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            class="short-input" style="text-align:right" v-model="info.nonFt" :disabled="type=='look'" />
                        </div>
                        <div class="input-box">
                            <p class="long-p">指导非全日制专硕费用：</p>
                            <a-input-number 
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            class="short-input" v-model="info.guidNonFt" :disabled="type=='look'" />
                        </div>
                        <div class="input-box">
                            <p class="long-p">教学事故扣发：</p>
                            <a-input-number 
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            class="short-input" v-model="info.accident"  :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">合计津贴/年：</p>
                            <a-input-number 
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            class="short-input" v-model="info.yearMoney" disabled/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">每月实发：</p>
                            <a-input-number 
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            class="short-input" style="text-align:right"  v-model="info.monthMoney" disabled/>
                        </div>
                    </div>
                </a-card>
                <a-card  :bordered="false" style="width:100%;margin-top:1rem" :headStyle="this.info.teachU < this.info.minTeach ? 'font-size:1vw;color:red':'font-size:1vw'">
                    <template slot="title">
                        <a-icon type="team" /> 规定本科教学基础教分（最低值）：{{info.minTeach}}
                    </template>
                    <div class="info-main">
                        <div class="input-box">
                            <p class="long-p">本科生教学：</p>
                            <a-input-number class="short-input" @change="totalScore()" v-model="info.teachU" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">全日制研究生教学：</p>
                            <a-input-number class="short-input"  @change="totalScore()" v-model="info.teachG" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">博士后合作导师：</p>
                            <a-input-number class="short-input"  @change="totalScore()" v-model="info.teachD" :disabled="type=='look'"/>
                        </div>
                    </div>
                </a-card>
                <a-card :bordered="false" style="width:100%;margin-top:1rem" :headStyle="this.info.resScore < this.info.minResearch ? 'font-size:1vw;color:red' :'font-size:1vw'">
                    <template slot="title">
                        <a-icon type="experiment" /> 规定科研分（最低值）：{{info.minResearch}}
                    </template>
                    <div class="info-main">
                        <div class="input-box">
                            <p class="long-p">科研业绩教分：</p>
                            <a-input-number class="short-input"  @change="totalScore()" v-model="info.resScore" :disabled="type=='look'"/>
                        </div>
                    </div>
                </a-card>
                <a-card :bordered="false" style="width:100%;margin-top:1rem" :headStyle="this.info.serviceScore < this.info.minService?'font-size:1vw;color:red':'font-size:1vw'">
                    <template slot="title">
                        <a-icon type="heart" /> 规定公共服务分（最低值）：{{info.minService}}
                    </template>
                    <div class="info-main">
                        <div class="input-box">
                            <p class="long-p">公共服务总分：</p>
                            <a-input-number class="short-input" v-model="info.serviceScore" disabled/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">担任新进教师指导教师：</p>
                            <a-input-number class="short-input" @change="serviceScore()"  v-model="info.guideNew" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">公共服务（本科生）：</p>
                            <a-input-number class="short-input" @change="serviceScore()"  v-model="info.examU" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">公共服务分值（研究生）：</p>
                            <a-input-number class="short-input" @change="serviceScore()"  v-model="info.publicService" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">公共服务分值（外事与重大会务）：</p>
                            <a-input-number class="short-input" @change="serviceScore()"  v-model="info.publicEventService" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">评定等级（ABCD）：</p>
                            <a-select class="short-input" allowClear v-model="info.grade" @change="serviceScore()" :disabled="type=='look'">                        
                                <a-select-option  value=3 >A(3)</a-select-option>
                                <a-select-option  value=2 >B(2)</a-select-option>
                                <a-select-option  value=0 >C(0)</a-select-option>
                                <a-select-option  value=-2 >D(-2)</a-select-option>
                            </a-select>
                        </div>
                        <div class="input-box">
                            <p class="long-p">公共服务分值（其他）：</p>
                            <a-input-number class="short-input" @change="serviceScore()"  v-model="info.publicOtherService" :disabled="type=='look'"/>
                        </div>
                    </div>
                </a-card>
                <a-card  :bordered="false" style="width:100%;margin-top:1rem" headStyle="font-size:1vw">
                    <template slot="title">
                        <a-icon type="more" /> 其它奖励
                    </template>
                    <div class="info-main">
                        <div class="input-box">
                            <p class="long-p">本科生教书育人卓越贡献奖：</p>
                            <a-input-number class="short-input" 
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            @change="totalScore()" v-model="info.cotentU" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">研究生教书育人卓越贡献奖：</p>
                            <a-input-number class="short-input"
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            @change="totalScore()"  v-model="info.cotentG" :disabled="type=='look'"/>
                        </div>
                        <div class="input-box">
                            <p class="long-p">科学研究卓越奖励：</p>
                            <a-input-number class="short-input"  
                            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" 
                            @change="totalScore()"  v-model="info.cotentO" :disabled="type=='look'"/>
                        </div>
                    </div>
                </a-card>
                <!-- <div class="input-box">
                    <p class="long-p">规定本科教学基础教分（最低值）：</p>
                    <a-input-number class="short-input"   v-model="info.minTeach" disabled/>
                </div> -->
                
                <!-- <div class="input-box">
                    <p class="long-p">规定科研分（最低值）：</p>
                    <a-input-number class="short-input"   v-model="info.minResearch" disabled/>
                </div> -->
                
                <!-- <div class="input-box">
                    <p class="long-p">规定公共服务分（最低值）：</p>
                    <a-input-number class="short-input"   v-model="info.minService" disabled/>
                </div> -->
                <a-card :bordered="false" style="width:100%;margin-top:1rem" headStyle="font-size:1vw">
                    <template slot="title">
                        <a-icon type="file-markdown" /> 备注
                    </template>
                    <div class="info-main">
                        <div class="input-box-center">
                            <p class="long-p"></p>
                            <a-textarea class="short-input" :rows="5"  v-model="info.comments" :disabled="type=='look'"/>
                        </div>
                    </div>
                </a-card>
                <a-card v-if="type == 'look'" :bordered="false" style="width:100%;margin-top:1rem" headStyle="font-size:1vw">
                    <template slot="title">
                        <a-icon type="question-circle" /> 申诉
                    </template>
                    <div class="info-main">
                            
                        <div class="input-box-center">
                            <p class="long-p"></p>
                            <div  class="short-input">
                                <a-button style="margin-right:2rem" @click="handleAdd('申诉')" type="primary" v-if="$store.state.user.userId == this.info.teacherId">
                                    申诉
                                </a-button>
                                <a-button  @click="handleAdd('回复')" type="primary" v-if="permissions.indexOf('faculty:assess:replied')>-1">
                                    回复
                                </a-button>
                                <a-table :columns="columns" :data-source="data" bordered>
                                </a-table>
                            </div>
                        </div>
                    </div>
                </a-card>
            </div>
        </div>
        <div class="btn-box" v-if="intoType != 'into'">
            <a-button @click="$router.go(-1)">取消</a-button>
            <a-button type="primary" v-if="type!='look'" @click="sub">提交</a-button>
            <a-button type="primary" v-if="type=='look' && $store.state.user.userId==info.teacherId" @click="confirm" :disabled="confirmStatus=='Y'">确认</a-button>
            <!-- <a-button type="primary" v-if="type=='look'" @click="confirm" :disabled="confirmStatus=='Y'">确认</a-button> -->
        </div>

        <a-modal
        :title="commitType"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
        >
            <a-textarea :rows="3" v-model="comments"/>
        </a-modal>
    </div>
    
</template>
<script>
    import { info,add,update,complaintList,complaint,replied,standard,confirm } from '@/baseAPI/allowance'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import { getSchoolYear } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                confirmStatus:'',
                type:'',
                assessYear:null,
                info:{
                    id:null,
                    totalScore:null,
                    teachU:null,
                    teachG:null,
                    teachD:null,
                    serviceScore:null,//公共服务总分
                    examU:null,//本科监考
                    publicService:null,
                    grade:null,
                    cotentU:null,//本科生教书育人卓越贡献奖
                    cotentG:null,//内容（卓越贡献奖）研究生教书育人
                    cotentO:null,//内容（学研究卓越奖励）
                    actualExcess:null,//
                    aeMoney:null,//超工作量金额(600元/分）
                    yearMoney:null,//合计津贴/年
                    postMoney:null,//工作量津贴
                    nonFt:null,//非全日制教学费用
                    guidNonFt:null,//指导非全日制专硕费用
                    accident:null,//教学事故扣发
                    monthMoney:null,//每月实发
                    resScore:null,//科研业绩教分
                    minWorkload:0,
                    minResearch:0,
                    minService:0,
                    minTeach:0,
                    guideNew:null
                },
                year:'',
                yearShowOne:false,
                jsArr:[],
                kcArr:[],
                permissions:[],
                icons:'<a-icon type="double-right" />',
                visible: false,
                confirmLoading: false,
                commitType:'',
                comments:'',
                pagination:{
                    pageSize: 6,
                    current: 1,
                    total:0,
                },
                data:[],
                columns:[
                    {
                        title: '序号',
                        align:'center',
                        width:50,
                        customRender: (text, row, index) => {
                            return { children: index+1};
                        },
                    },
                    {
                        title: '创建时间',
                        dataIndex:'createTime',
                        align: 'center',
                        width:120,
                    },
                    {
                        title: '类型',
                        dataIndex:'type',
                        align: 'center',
                        width:80,
                        customRender: (text, row, index) => {
                            return text == '1' ? '申诉':'回复'
                        },
                    },
                    {
                        title: '内容',
                        dataIndex:'comments',
                        width:200
                    },
                    {
                        title: '创建人',
                        dataIndex:'createBy',
                        align: 'center',
                        width:100,
                    },
                ]
            }
        },
        props:{
            intoType:null,intoCourseId:null
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.year=getSchoolYear()+''
            this.info.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
        
            getTeacher().then(res=>{
                this.jsArr=res.data;
            })


            Math.formatFloat = function (f, digit) {  // 解决js精度丢失问题
                var m = Math.pow(10, digit);
                return Math.round(f * m, 10) / m;
            }

            this.type=this.$route.query.type;
            
            if(this.type != 'add'){
                setTimeout(()=>{
                    info(this.$route.query.id).then(res=>{
                        this.info=res.data;
                        this.confirmStatus=res.data.confirmStatus;
                        complaintList(this.info.id).then(res=>{
                            this.data = res.data
                        })
                        if(this.type != 'look'){
                            standard(this.info.teacherId,this.info.schoolYear).then(res=>{
                                this.info.postMoney=res.data.postMoney
                                this.info.minWorkload=res.data.minWorkload
                                this.info.minTeach=res.data.minTeach
                                this.info.minResearch=res.data.minResearch
                                this.info.minService=res.data.minService
                                this.assessYear = res.data.assessYear
                                this.totalScore()
                            })
                        }
                        })
                },1000)
            }

        },
        watch:{
            info:{
                handler(newVal){
                    if(this.type != 'look'){
                        this.actualExcess()
                        this.aeMoney()
                        this.yearMoney()
                        this.monthMoney()
                    }
                },
                deep: true
            }
        },
        methods:{
            confirm(){
                confirm(this.$store.state.user.userId,this.info.schoolYear).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'确认成功',
                        });
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                    info(this.$route.query.id).then(res=>{
                        this.confirmStatus=res.data.confirmStatus;
                    })
                })
            },
            handleAdd(type){
                this.commitType = type;
                this.visible = true;
            },
            handleOk(e) {
                this.confirmLoading = true;

                if(this.commitType == '申诉'){
                    complaint({'assessId':this.info.id,'comments':this.comments}).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'新增申诉成功',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        complaintList(this.info.id).then(res=>{
                            this.data = res.data
                        })
                        this.visible = false;
                        this.confirmLoading = false;
                    })
                }else if(this.commitType == '回复'){
                    replied({'assessId':this.info.id,'comments':this.comments}).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'新增回复成功',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        complaintList(this.info.id).then(res=>{
                            this.data = res.data
                        })
                        this.visible = false;
                        this.confirmLoading = false;
                    })
                }
            },
            handleCancel(e) {
                this.visible = false;
            },
            into(){
                this.year=this.getTimeStr(new Date(),'yyyy')
                this.info.schoolYear=this.year+'-'+(this.year-0+1);
                list().then(res=>{
                    this.kcArr=res.data;
                })
                getTeacher().then(res=>{
                    this.jsArr=res.data;
                })
                this.type='look';
                setTimeout(()=>{
                    info(this.intoCourseId).then(res=>{
                        this.info=res.data;
                    })
                },1000)
                                     
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                // var arr=['schoolYear','semester','courseName','credit','courseId','teacherName','teacherId','classTime','classId','classRoom','studentCapacity','studentNumber','answerTime','answerRoom']
                // for(let i=0;i<arr.length;i++){
                //     if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                //         isSub=false;
                //         break;
                //     }
                // }
                if(isSub){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增业绩津贴成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改业绩津贴成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            monthMoney(){
                this.info.monthMoney = Math.formatFloat(this.info.yearMoney / 12,2);
            },
            yearMoney(){
                if(this.info.totalScore < this.info.minWorkload){
                    this.info.yearMoney = Math.formatFloat((this.info.totalScore / this.info.minWorkload) * this.info.postMoney * 12 + this.info.nonFt + this.info.guidNonFt - this.info.accident,2);
                }else if(this.assessYear == 0){
                    this.info.yearMoney = this.info.postMoney * 12
                    this.info.aeMoney = 0
                }else if(this.info.teachU < this.info.minTeach && this.info.aeMoney >= 0){
                    this.info.yearMoney = this.info.postMoney * 12 + this.info.nonFt + this.info.guidNonFt - this.info.accident;
                }else{
                    this.info.yearMoney = this.info.postMoney * 12 + this.info.aeMoney + this.info.nonFt + this.info.guidNonFt - this.info.accident;
                }
            },
            aeMoney(){
                this.info.actualExcess == null ? this.info.actualExcess = 0 : null
                this.info.aeMoney = Math.formatFloat(this.info.actualExcess * 600 + this.info.cotentU + this.info.cotentG + this.info.cotentO,2);
            },
            actualExcess(){
                this.info.totalScore == null ? this.info.totalScore = 0 : 0;
                this.info.minWorkload == null ? this.info.minWorkload = 0 : 0;
                this.info.actualExcess = Math.formatFloat(parseFloat(this.info.totalScore) - parseFloat(this.info.minWorkload),2);
                if(this.info.actualExcess<0){
                    this.info.actualExcess=0
                }
            },
            serviceScore(){
                this.info.serviceScore = 0;
                this.info.guideNew == null ? this.info.guideNew = 0 : null;
                this.info.examU == null ? this.info.examU = 0 : null;
                this.info.publicService == null ? this.info.publicService = 0 : null;
                this.info.grade == null ? this.info.grade = 0 : null;
                this.info.serviceScore = Math.formatFloat(parseFloat(this.info.guideNew) + parseFloat(this.info.examU) + parseFloat(this.info.publicService) + parseFloat(this.info.publicEventService) + parseFloat(this.info.grade),2) + parseFloat(this.info.publicOtherService)
                this.totalScore()
            },
            totalScore(){
                this.info.totalScore = 0;
                this.info.teachU == null ? this.info.teachU = 0 : null;
                this.info.teachG == null ? this.info.teachG = 0 : null;
                this.info.teachD == null ? this.info.teachD = 0 : null;
                this.info.resScore == null ? this.info.resScore = 0 : null;
                this.info.serviceScore == null ? this.info.serviceScore = 0 : null;
                this.info.cotentU == null ? this.info.cotentU = 0 : null;
                this.info.cotentG == null ? this.info.cotentG = 0 : null;
                this.info.cotentO == null ? this.info.cotentO = 0 : null;
                this.info.totalScore = parseFloat(this.info.teachU) + parseFloat(this.info.teachG) + parseFloat(this.info.teachD) + parseFloat(this.info.resScore) + parseFloat(this.info.serviceScore) ;
                if(this.info.resScore < this.info.minResearch){
                    this.info.totalScore = this.info.totalScore - (this.info.minResearch - this.info.resScore)
                }
                if(this.info.serviceScore < this.info.minService){
                    this.info.totalScore = this.info.totalScore - (this.info.minService - this.info.serviceScore)
                }
                this.info.totalScore = Math.formatFloat(this.info.totalScore,2)
                
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherName==value){
                        this.info.orgName=this.jsArr[i].orgName
                        this.info.orgCode=this.jsArr[i].orgCode
                        this.info.teacherId=this.jsArr[i].teacherId
                        this.info.technicalTitleCode=this.jsArr[i].technicalTitleCode
                        this.info.technicalTitleName=this.jsArr[i].technicalTitleName
                    }
                }
                // if(this.info.technicalTitleName == '教授' || this.info.technicalTitleName == '特聘三级' || this.info.technicalTitleName == '特聘教授'){
                //     this.info.postMoney=10000
                //     this.info.minWorkload=60
                //     this.info.minTeach=3
                //     this.info.minResearch=6
                //     this.info.minService=4
                // }else if(this.info.technicalTitleName == '副教授' || this.info.technicalTitleName == '副研究员'){
                //     this.info.postMoney=6650
                //     this.info.minWorkload=40
                //     this.info.minTeach=4.5
                //     this.info.minResearch=4
                //     this.info.minService=4
                // }else if(this.info.technicalTitleName == '讲师'){
                //     this.info.postMoney=5000
                //     this.info.minWorkload=30
                //     this.info.minTeach=4.5
                //     this.info.minResearch=3
                //     this.info.minService=4
                // }
                standard(this.info.teacherId,this.info.schoolYear).then(res=>{
                    this.info.postMoney=res.data.postMoney
                    this.info.minWorkload=res.data.minWorkload
                    this.info.minTeach=res.data.minTeach
                    this.info.minResearch=res.data.minResearch
                    this.info.minService=res.data.minService
                    this.assessYear = res.data.assessYear
                    this.totalScore()
                })

            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.info.schoolYear=this.year+'-'+(this.year-0+1);
                this.info.semester='';
                this.yearShowOne = false;
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 99%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box .long-p{
        width: 20rem;
        text-align: right;
    }
    .info-main .input-box .short-input{
        width: calc(100% - 15rem);
    }

    .info-main .input-box-center .long-p{
        width: 20rem;
        text-align: right;
    }
    .info-main .input-box-center .short-input{
        width: calc(100% - 5rem);
    }

    .info-main .input-box .answer-input{
        width: calc(100% - 10rem);
        border-color:red;
    }

    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    /* .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    } */
    .action-btn{
        background-color: #1890ff;
        color: #fff;
        line-height: 32px;
        padding: 0 15px;
        height: 32px;
        border-radius: 4px;
    }

    .editable-add-btn {
        margin-bottom: 8px;
    }

    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
    }
</style>
